import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=f6a4b16c&scoped=true&"
import script from "./InfoRow.vue?vue&type=script&lang=js&"
export * from "./InfoRow.vue?vue&type=script&lang=js&"
import style0 from "./InfoRow.vue?vue&type=style&index=0&id=f6a4b16c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a4b16c",
  null
  
)

export default component.exports